module.exports = __webpack_public_path__ + "static/media/puzzle--big.af790364.png";